import { render } from "./ServiceFbPayDone.vue?vue&type=template&id=d2a2d6a8"
import script from "./ServiceFbPayDone.vue?vue&type=script&lang=js"
export * from "./ServiceFbPayDone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__